export default function ResultsLayout({ children, preview, PreviewPanel, previewProps }) {
    return (
        <div className="flex-grow-1 overflow-hidden row">
            <div className={`${preview ? 'col-md-6 col-xxl-5' : 'col-12'} results-panel`}>{children}</div>
            {preview && (
                <div className="col-md-6 col-xxl-7 preview-panel d-flex flex-column mh-100">
                    <PreviewPanel item={preview} {...previewProps} />
                </div>
            )}
        </div>
    )
}
